<template>
  <DataTable
    :value="value"
    :columns="columns"
    :row-wrapper="wrappers.row"
    :cell-wrapper="wrappers.cell"
    v-bind="$attrs"
    v-on="{ ...$listeners, 'update:selected': $ev => updateSelected($ev) }"
  >
    <template v-for="column in columns" v-slot:[column.id]="{ item }">
      <component :is="column.component" :key="column.id" :config="column" :item="item" v-bind="column" />
    </template>
  </DataTable>
</template>

<script>
import DataTable from '@/components/DataTable'
import Fields from './Fields'
import { Debounce } from '@/utils'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Array,
      default: () => [],
    },
    wrappers: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    columns() {
      const getComponent = v => {
        if (typeof v !== 'string') return v
        return Fields[v]
      }

      return this.config.map(e => ({ ...e, component: getComponent(e.component) }))
    },
  },
  methods: {
    updateSelected(value) {
      this.$emit('update:selected', value)
    },
  },
  components: {
    DataTable,
  },
}
</script>

<style lang="scss"></style>
